module.exports = __webpack_public_path__ + "img/img5.b3e4607e.png";